// extracted by extract-css-chunks-webpack-plugin
module.exports = {"reason":"tasks-email-revision-reason__reason--1WvXH"};